import './App.css';
import Banner from './Components/Banner/Banner';
import NavBar from './Components/NavBar/NavBar';

function App() {
  return (
    <div className="App">
      <Banner/>
      <NavBar/>
    </div>
  );
}

export default App;
